import React from 'react'
import Form from './Form'
import { ContactUs } from './styles'
export default (
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<any>, any> | null => {
  return (
    <ContactUs data-type='main'>
      <div data-section='contact-us'>
        <img
          className='lazyload'
          loading='lazy'
          width='700'
          height='824'
          data-src='//d3t95n9c6zzriw.cloudfront.net/trade/contact/contact-us-image.jpg'
          alt='Saatchi For The Trade - Contact Us'
          itemProp='image'
        />

        <div data-type='contact-form'>
          <Form closeModal={() => null} />
        </div>
      </div>
    </ContactUs>
  )
}